export const prettyUnit = (unit?: string) => {
  if (unit && unit.length > 0) {
    return (
      <>
        {unit.split('').map((char, index) => {
          const key = `${char}-${index}-${Math.random()}`;
          if (!isNaN(parseInt(char))) {
            return <sup key={key}>{char}</sup>
          }

          return <span key={key}>{char}</span>
        })}
      </>
    );
  }
  return <>{unit}</>;
};
